import logo from "@/assets/logo.png";

export const Logo = ({ className = "w-7 h-7" }) => (
  <img
    src={logo}
    alt="Angiò A.I."
    className={`${className} rounded-md object-cover shrink-0`}
    data-testid="app-logo"
  />
);
